"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const S = (0, tslib_1.__importStar)(require("./styles"));
const Card = ({ alt, backgroundImage, onClick, cardText, width, height, }) => {
    return ((0, jsx_runtime_1.jsxs)(S.Container, Object.assign({ onClick: onClick, "data-testid": "card" }, { children: [(0, jsx_runtime_1.jsx)(S.CardFigure, { alt: alt, backgroundImage: backgroundImage, width: width, height: height }, void 0), (0, jsx_runtime_1.jsx)(S.CardTitle, Object.assign({ as: "h2" }, { children: cardText }), void 0)] }), void 0));
};
exports.default = Card;
